import React from "react";
import Banner from '../component/Banner/Banner'
import About from '../component/About/About'
import Experience from "../component/Experience/Experience";
import Portfolio from "../component/Portfolio/Portfolio";
import Contact from "../component/Contact/Contact";
import Navigation from '../component/Navigation/Navigation'
import Footer from "../component/Footer/Footer";
import Landing from "../container/Landing";
import useAOS from "../hooks/useAOS";
import OtherProjects from "../component/OtherProjects/OtherProjects";

// import TimeLine from "../component/Experience/TimeLine";
// import {device, matchedMedia} from "../utils/CheckDevice";
// import Cursor from "../component/Cursor/Cursor";
// import useLocoScroll from "../hooks/useLocoScroll";

function Index() {
    useAOS()

    /*const ref = useRef(null)
    const [preloader, setPreload] = useState(true)


    useLocoScroll(!preloader)

    useEffect(() => {
      if (!preloader && ref) {
        if (typeof window === "undefined" || !window.document) return
      }
    }, [preloader])

    const [timer, setTimer] = React.useState(3)

    const id = React.useRef(null)

    const clear = () => {
      window.clearInterval(id.current)
      setPreload(false)
    }

    React.useEffect(() => {
      id.current = window.setInterval(() => {
        setTimer((time) => time - 1);
      }, 1000)
      return () => clear()
    }, [])

    React.useEffect(() => {
      if (timer === 0) {
        clear();
      }
    }, [timer])

    if (typeof window === "undefined" || !window.document) return null*/

    return (
        <>
            {/*{(device() === 'desktop' && matchedMedia()) && <Cursor/>}*/}
            {/*{preloader ? (*/}
            {/*    <div><h1>Loading...</h1></div>*/}
            {/*) : (*/}
            <Landing>
                <div
                    // className="main-container"
                    // id="main-container"
                    // data-scroll-container
                    // ref={ref}
                >
                    <Navigation/>
                    <Banner/>
                    <div style={{position: 'relative'}} className={'max-w-7xl mx-auto'}>
                        <div className='pb-32 pt-2 md:pt-20'>
                            <About/>
                            {/*<Skills/>*/}
                        </div>
                        <div className='pb-32' id="experience">
                            <Experience/>
                            {/*<TimeLine/>*/}
                        </div>
                        <div className='pb-32' id="portfolio">
                            <Portfolio/>
                        </div>
                        <div className='pb-32' id="otherProjects">
                            <OtherProjects/>
                        </div>
                        {/*<Games/>*/}
                    </div>
                    <div className='bg-nfr-color-200 dark:bg-nfr-color-800' id='contact'>
                        <div className={'max-w-7xl mx-auto'}>
                            <Contact/>
                        </div>
                    </div>
                    {/*<MaintenancePopup/>*/}
                    <div className={'max-w-7xl mx-auto'}>
                        <Footer/>
                    </div>
                </div>
            </Landing>
            {/*)}*/}
        </>
    );
}

export default Index;
